/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon16Regular = forwardRef('ShapeTriangleUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.325 2.193a2 2 0 0 1 3.35 0l5.69 8.713c.869 1.33-.085 3.094-1.674 3.094H2.309C.72 14-.234 12.237.635 10.906l5.69-8.713Zm2.094.82a.5.5 0 0 0-.838 0l-5.69 8.714a.5.5 0 0 0 .418.773h11.382a.5.5 0 0 0 .418-.773L8.42 3.013Z" })));
});
